<div class="a-titulo">
  MANTENIMIENTO DE CLIENTES
</div>
<div class="a-w1-column">
  <p-toast key="toastGeneral" position="top-right" [life]="5000"
    [style]="{ 'z-index': 9999, 'top': '280px !important' }">></p-toast>
  <form [formGroup]="group" class="a-w1-row">
    <div class="a-w1 a-w1-row">
      <!-- <div class="a-example-full-width-alterno-content-5"> -->
      <p-floatlabel variant="in" class="a-w4">
        <!-- <input formControlName="numdocumento" type="text" pInputText /> -->
        <input formControlName="numdocumento" pInputText type="text" class="w-full md:w-full" />
        <label for="float-label">Número Documento</label>
      </p-floatlabel>
      <!-- </div>
          <div class="a-example-full-width-alterno-content-5"> -->
      <!-- <span class="p-float-label"> -->
      <!-- <input formControlName="razonsocial" type="text" pInputText />
                  <label for="float-label">Razón Social</label> -->
      <p-floatlabel variant="in" class="a-w6">
        <input formControlName="razonsocial" pInputText type="text" class="w-full md:w-full" />
        <label for="razonSocial">Razon Social</label>
      </p-floatlabel>
      <!-- </div> -->
      <div style="display: flex; gap: 20px;">
        <p-button icon="pi pi-search" label="Buscar" (onClick)="search()"></p-button>
        <p-button icon="pi pi-plus" label="Nuevo" (onClick)="nuevo()"></p-button>
        <p-button icon="pi pi-file-excel" label="Exportar" (onClick)="exportExcel()"></p-button>
        <p-button icon="pi pi-sign-out" label="Salir" (onClick)="salirBandejaPrincipal()"></p-button>
      </div>
    </div>
  </form>
</div>
<app-datatable [metadataTable]="metadataTable" [dataTable]="dataTable" [filterGlobal]="true">
  <ng-template #addHeaderStart>
    <th class="header">
      <div class="items-header">
        <span>Acción</span>
      </div>
    </th>
  </ng-template>
  <ng-template #addBodyStart let-row="row">
    <td class="a-datatable-datos-body-accion row-space">
      <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-info p-button-outlined"
        (onClick)="editEntidad('',row)" pTooltip="Editar" tooltipPosition="top"></p-button>
      <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-danger p-button-outlined"
        (onClick)="eliminar(row)" pTooltip="Eliminar" tooltipPosition="top"></p-button>
    </td>
  </ng-template>
</app-datatable>

<div class="footer"></div>

<p-dialog header="" [(visible)]="visible" [style]="{width: '60vw',height: '100vh'}" appendTo="body"
  [maximizable]="true">
  <br>
  <div style="justify-content: center; display: flex; gap: 20px;">
    <p-button *ngIf="visiblebtn" label="Guardar" (onClick)="TransaccionEntidad('I', 0)"></p-button>
    <p-button *ngIf="!visiblebtn" label="Actualizar" (onClick)="TransaccionEntidad('U', 0)"></p-button>
    <p-button label="Salir" (onClick)="salir()"></p-button>
  </div>
  <p-tabView class="a-example-full-width-alterno-content">
    <p-tabPanel header="Datos Generales">
      <form [formGroup]="groupPoppupDG" class="a-w1" style="margin: 0;">
        <div class="a-w1-row">

          <p-floatlabel variant="in" class="a-w2">
            <!-- <input formControlName="codigo" type="text" pInputText [readOnly]="true" /> -->
            <input formControlName="codigo" type="text" pInputText [readOnly]="true" class="w-full md:w-full" />
            <label for="float-label">Código</label>
          </p-floatlabel>

          <div class="a-w2">
            <span class="p-float-label" class="activo-centrado" style="justify-items: center;">
              <div class="flex align-items-center gap-1">
                <p-checkbox formControlName="activo" [binary]="true" inputId="binary"></p-checkbox>
                <label for="activo">Activo</label>
              </div>
            </span>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <span class="radiobtn-center">
              <div *ngFor="let t of tipo" class="field-checkbox">
                <p-radioButton [inputId]="t.key" [value]="t.key" formControlName="tipopersona"
                  (ngModelChange)="verInputs($event)"></p-radioButton>
                <label [for]="t.key" class="ml-2">{{ t.name }}</label>
              </div>
            </span>
          </div>
          <div class="a-w2" class="activo-centrado" style="justify-items: center;">
            <div class="flex align-items-center gap-1">
              <span class="p-float-label">
                <p-checkbox formControlName="serviciologistico" [binary]="true" inputId="binary"></p-checkbox>
                <label style="padding-left: 20px;">Servicio Logistico</label>
              </span>
            </div>
            <div *ngIf="estadoEditar == false" class="flex align-items-center gap-1">
              <span class="p-float-label">
                <p-checkbox formControlName="informar_facturacion" [binary]="true" inputId="binary"></p-checkbox>
                <label for="binary" style="padding-left: 20px;">Enviar Correo a Facturación</label>
              </span>
              <i class="pi pi-exclamation-circle"
                pTooltip="Envío de correo Nuevo Cliente registrado al área de facturación" tooltipPosition="right"
                style="font-size: 1.2rem; cursor: pointer; color: gray;"></i>
            </div>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">

          <p-floatlabel variant="in" class="a-w2">
            <p-select [options]="ListaTodosTipoDoc" optionLabel="nombre" formControlName="tipodocumento"
              optionValue="codigo" appendTo="body" (onChange)="verNumDoc($event)" styleClass="w-full md:w-full text-xs">
            </p-select>
            <label for="float-label">Tipo Documento</label>
          </p-floatlabel>

          <div class="a-w2" *ngIf="visiblenumdoc">
            <p-inputgroup>

              <p-floatlabel variant="in" class="a-w2">
                <!-- <input formControlName="numerodocumento" type="text" pInputText /> -->
                <input formControlName="numerodocumento" pInputText type="text" class="w-full md:w-full" />
                <label for="float-label">Número Documento</label>
              </p-floatlabel>
              <p-toast key="toast1"></p-toast>
              <p-toast key="toast2"></p-toast>
              <button type="button" pButton pRipple icon="pi pi-search" (click)="validarDocumento()"
                styleClass="p-button-info"></button>
            </p-inputgroup>
            <!-- <div class="p-inputgroup">
                          
                          <p-toast key="toast1"></p-toast>
                          <p-toast key="toast2"></p-toast>
                          <button type="button" pButton pRipple icon="pi pi-search" (click)="validarDocumento()"
                              styleClass="p-button-info"></button>
                      </div> -->
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;" *ngIf="juridica">

          <p-floatlabel variant="in" class="a-w2">
            <!-- <input formControlName="razonsocial" type="text" pInputText /> -->
            <input formControlName="razonsocial" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Razón Social</label>
          </p-floatlabel>

          <p-floatlabel variant="in" class="a-w2">
            <!-- <input formControlName="razoncomercial" type="text" pInputText /> -->
            <input formControlName="razoncomercial" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Razón Comercial</label>
          </p-floatlabel>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
          <p-floatlabel variant="in" class="a-w1">
            <input formControlName="nomgerente" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Nombre Gerente</label>
          </p-floatlabel>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1" class="w-full md:w-full">
              <p-datepicker formControlName="fechanacimientog" appendTo="body" [showIcon]="true"
                styleClass="w-full md:w-full" dateFormat="dd/mm/yy" [maxDate]="fechaActual">
              </p-datepicker>
              <label for="float-label">Fecha Nacimiento</label>
            </p-floatlabel>
          </div>
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1" class="w-full md:w-full">
              <p-datepicker formControlName="fechaAniversariog" appendTo="body" [showIcon]="true"
                styleClass="w-full md:w-full" dateFormat="dd/mm/yy">
              </p-datepicker>
              <label for="float-label">Fecha Aniversario</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
          <!-- <div class="a-w2">
                      <span class="p-float-label">
                          <input formControlName="apellidopaterno" type="text" pInputText />
                          <label for="float-label">Apellido Paterno</label>
                      </span>
                  </div> -->
          <div class="a-w1-row" style="padding-top: 20px;">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="apellidopaterno" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Apellido Paterno</label>
            </p-floatlabel>
          </div>
          <!-- <div class="a-w2">
                      <span class="p-float-label">
                          <input formControlName="apellidomaterno" type="text" pInputText />
                          <label for="float-label">Apellido Materno</label>
                      </span>
                  </div> -->
          <div class="a-w1-row" style="padding-top: 20px;">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="apellidomaterno" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Apellido Materno</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
          <!-- <div class="a-w2">
                      <span class="p-float-label">
                          <input formControlName="nombres" type="text" pInputText />
                          <label for="float-label">Nombres</label>
                      </span>
                  </div> -->
          <div class="a-w1-row" style="padding-top: 20px;">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="nombres" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Nombres</label>
            </p-floatlabel>
          </div>
          <div class="a-w2">
            <span class="radiobtn-center">
              <div *ngFor="let s of sexo" class="field-checkbox">
                <p-radioButton [inputId]="s.key" [value]="s.key" formControlName="sexo"></p-radioButton>
                <label [for]="s.key" class="ml-2">{{ s.name }}</label>
              </div>
            </span>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
          <!-- <div class="a-w2">
                      <span class="p-float-label">
                          <input formControlName="area" type="text" pInputText />
                          <label for="float-label">Área</label>
                      </span>
                  </div> -->
          <div class="a-w1-row" style="padding-top: 20px;">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="area" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Área</label>
            </p-floatlabel>
          </div>
          <!-- <div class="a-w2">
                      <span class="p-float-label">
                          <input formControlName="cargo" type="text" pInputText />
                          <label for="float-label">Cargo</label>
                      </span>
                  </div> -->
          <div class="a-w1-row" style="padding-top: 20px;">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="cargo" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Cargo</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1" class="w-full md:w-full">
              <p-datepicker formControlName="fechanacimiento" appendTo="body" [showIcon]="true"
                styleClass="w-full md:w-full" dateFormat="dd/mm/yy" [maxDate]="fechaActual">
              </p-datepicker>
              <label for="float-label">Fecha Nacimiento</label>
            </p-floatlabel>
          </div>
          <!-- <p-floatlabel variant="in">
                          <p-datepicker formControlName="fechanacimiento" showIcon iconDisplay="input" size="small"
                              styleClass="w-full" inputStyleClass="w-full md:w-full text-xs" />
                          <label for="fechaingreso">Fecha Nacimiento</label>
                      </p-floatlabel>
                  </div> -->
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1" class="w-full md:w-full">
              <p-datepicker formControlName="fechaingreso" appendTo="body" [showIcon]="true"
                styleClass="w-full md:w-full" dateFormat="dd/mm/yy">
              </p-datepicker>
              <label for="float-label">Fecha Ingreso</label>
            </p-floatlabel>
          </div>
          <!-- <p-floatlabel variant="in">
                          <p-datepicker formControlName="fechaingreso" showIcon iconDisplay="input" size="small"
                              styleClass="w-full" inputStyleClass="w-full md:w-full text-xs" />
                          <label for="fechaingreso">Fecha Ingreso</label>
                      </p-floatlabel>
                  </div> -->
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="correo" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Contrato Mandato</label>
            </p-floatlabel>
          </div>
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="correo_otros_traficos" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Otros Tráficos</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">

          <p-floatlabel variant="in" class="a-w2">
            <!-- <input formControlName="contactonombre" type="text" pInputText /> -->
            <input formControlName="contactonombre" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Contacto Nombre</label>
          </p-floatlabel>

          <p-floatlabel variant="in" class="a-w2">
            <!-- <input formControlName="contactoapellidos" type="text" pInputText /> -->
            <input formControlName="contactoapellidos" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Apellidos</label>
          </p-floatlabel>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <p-floatlabel variant="in" class="a-w1">
            <input formControlName="correoexport" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Correo Exportaciones</label>
          </p-floatlabel>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="correo_facturacion" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Facturación</label>
            </p-floatlabel>
          </div>
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1">
              <p-select [options]="ListarTodosSegmento" placeholder="‎ " optionLabel="nombre" formControlName="segmento"
                optionValue="codigo" appendTo="body" styleClass="w-full md:w-full text-xs">
              </p-select>
              <label for="float-label">Segmento</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <p-floatlabel variant="in" class="a-w1">
            <input formControlName="web" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Web</label>
          </p-floatlabel>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="telefono_fijo" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Teléfono Fijo</label>
            </p-floatlabel>
          </div>
          <div class="a-w2">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="teléfono_movil" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Teléfono Móvil</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <p-floatlabel variant="in" class="a-w1">
            <input formControlName="direccion" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Dirección Fiscal</label>
          </p-floatlabel>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <p-floatlabel variant="in">
              <p-select [options]="listPais" appendTo="body" formControlName="pais" optionLabel="nombre"
                optionValue="codigo" styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true"
                [filter]="true" (onChange)="onPaisSeleccionado($event, 'EVE')" />
              <label for="anio">País</label>
            </p-floatlabel>
          </div>
          <div class="a-w2">
            <p-floatlabel variant="in">
              <p-select [options]="listDepartamento" appendTo="body" optionLabel="ubiG_Desc"
                formControlName="departamento" optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs"
                [filter]="true" [showClear]="true" [filter]="true"
                (onChange)="onDepartamentoSeleccionado($event, 'EVE')" />
              <label for="departamento">Departamento</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <p-floatlabel variant="in">
              <p-select [options]="listProvincia" appendTo="body" formControlName="provincia" optionLabel="ubiG_Desc"
                optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true"
                [filter]="true" (onChange)="onprovinciaSeleccionada($event, 'EVE')" />
              <label for="provincia">Provincia</label>
            </p-floatlabel>
          </div>
          <div class="a-w2">
            <p-floatlabel variant="in">
              <p-select [options]="listDistrito" appendTo="body" optionLabel="ubiG_Desc" formControlName="distrito"
                optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true"
                [filter]="true" />
              <label for="distrito">Distrito</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
            <div class="flex align-items-center gap-1">
              <span class="p-float-label">
                <p-checkbox formControlName="nodomiciliado" [binary]="true" inputId="binary"></p-checkbox>
                <label style="padding-left: 20px;">No Domiciliado</label>
              </span>
            </div>
            <!-- <div class="flex align-items-center gap-1">
                <span class="p-float-label">
                  <p-checkbox formControlName="vip" [binary]="true" inputId="binary"></p-checkbox>
                  <label style="padding-left: 20px;">VIP</label>
                </span>
              </div> -->
            <!-- <div class="flex align-items-center gap-1">
                              <span class="p-float-label">
                                  <p-checkbox formControlName="prospecto" [binary]="true"
                                      inputId="binary"></p-checkbox>
                                  <label style="padding-left: 20px;">Prospecto</label>
                              </span>
                          </div> -->
          </div>
          <div class="a-w2">
            <div class="a-w1-row">
              <!-- <div class="a-w1">
                              <span class="p-float-label">
                                  <p-datepicker formControlName="fechacredito" appendTo="body" [showIcon]="true"
                                      class="p-inputtext-sm" dateFormat="dd/mm/yy" [style]="{'width': '100%'}">
                                  </p-datepicker>
                                  <label for="float-label">Fecha Crédito</label>
                              </span>
                          </div> -->
              <p-floatlabel variant="in" class="a-w2">
                <p-datepicker formControlName="fechacredito" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"
                  styleClass="w-full md:w-full " inputStyleClass="w-full md:w-full">
                </p-datepicker>
                <label for="float-label">Fecha Crédito</label>
              </p-floatlabel>
            </div>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w2">
            <div class="a-w1-row" style="padding-top: 20px;">
              <!-- <div class="a-w1">
                              <span class="p-float-label">
                                  <p-inputNumber [showButtons]="true" formControlName="diascreditos"
                                      inputId="minmax-buttons" [style]="{'width': '100%'}" [min]="0"> </p-inputNumber>
                                  <label for="float-label">Días Créditos</label>
                              </span>
                          </div> -->
              <div class="a-w1">
                <p-floatlabel variant="in">
                  <p-inputNumber inputId="minmax-buttons" [showButtons]="true" [min]="0" [style]="{ width: '100%' }"
                    formControlName="diascreditos" class="w-full md:w-full"></p-inputNumber>
                  <label for="float-label">Días Créditos</label>
                </p-floatlabel>
              </div>
            </div>
          </div>
          <div class="a-w2">
            <span class="p-float-label" class="activo-centrado" style="justify-items: center;">
              <div class="flex align-items-center gap-1">
                <p-checkbox formControlName="to_order" [binary]="true" inputId="binary"></p-checkbox>
                <label for="activo">To Order</label>
              </div>
            </span>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px; ">
          <div class="a-w1">
            <span style="font-size: 15px; display: flex; padding-top: 20px;padding-bottom: 15px;">Observaciones</span>
            <span class="p-float-label">
              <textarea rows="5" cols="30" pInputTextarea formControlName="observaciones"
                style="width: 100%;"></textarea>
            </span>
          </div>
        </div>
      </form>
    </p-tabPanel>
    <p-tabPanel header="Otros Datos">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <p-accordion [activeIndex]="activeIndex" [multiple]="true">
        <p-accordionTab header="Servicios">
          <app-datatable [rowEdit]="true" [addRow]="true" [rowDelete]="true" [metadataTable]="metadataTableServicios"
            [dataTable]="dataTableServicios" [key]="'key'" [defaultRow]="defaultRowServicios"
            (onDpChangeEvento)="onServiciosChange($event)" [onDpValueChangeEvento]="onDpChangeTblServicios">
          </app-datatable>
          <div class="example-full-width-alterno100" style="margin-top: 20px;">
            <app-datatable [metadataTable]="metadataTableAuditoriaServicios" [dataTable]="dataTableAuditoriaServicios"
              [key]="'key'" [customButtons]="customAuditoriaServicios" [title]="'AUDITORIA DE SERVICIOS'">
            </app-datatable>
          </div>
        </p-accordionTab>
      </p-accordion>
    </p-tabPanel>
    <p-tabPanel header="Datos Financieros">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <p-accordion [activeIndex]="activeIndex" [multiple]="true">
        <p-accordionTab header="Datos Financieros">
          <form [formGroup]="groupPoppupD" class="a-w1" style="margin: 0;">
            <div class="a-w1-row">
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esMandato" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">Mandato</label>
                  </span>
                </div>
              </div>
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esExportaciones" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">Exportaciones</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esOtrosTraficos" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">Otros Tráficos</label>
                  </span>
                </div>
              </div>
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esSli" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">SLI</label>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="Límite de Crédito">
          <p-toast key="toast3"></p-toast>
          <app-datatable [metadataTable]="metadataTableLimiteCredito" [dataTable]="dataTableLimiteCredito"
            [addRow]="true" [rowEdit]="true" [key]="'key'">
            <ng-template #addHeaderEnd>
              <th class="header">
              </th>
            </ng-template>
            <ng-template #addBodyEnd let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-button icon="pi pi-history" styleClass="p-button-rounded p-button-warning p-button-outlined"
                  (onClick)="op.toggle($event)" pTooltip="Ver Historial" tooltipPosition="top"></p-button>
              </td>
              <p-overlayPanel #op [style]="{'width': '630px'}" (onShow)="verHistorial('',row)">
                <ng-template pTemplate="content">
                  <app-datatable [metadataTable]="metadataTableHistorial" [dataTable]="dataTableHistorial">
                  </app-datatable>
                </ng-template>
              </p-overlayPanel>
            </ng-template>
          </app-datatable>
        </p-accordionTab>

        <p-accordionTab header="Bloqueo">
          <form [formGroup]="groupPoppupB" class="a-w1" style="margin: 0;">
            <div class="a-w1-row">
              <div class="a-w1">
                <span class="p-float-label" class="activo-centrado">
                  <div class="flex align-items-center gap-1">
                    <p-checkbox formControlName="bloqueado" [binary]="true" inputId="binary"
                      (ngModelChange)="cargarInputBloqueo($event)"></p-checkbox>
                    <label for="activo">Bloqueado</label>
                  </div>
                </span>
              </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
              <div class="a-w2">
                <p-float-label variant="on">
                  <input formControlName="usuariobloqueo" type="text" pInputText />
                  <label for="float-label">Usuario</label>
                </p-float-label>
              </div>
              <div class="a-w2">
                <!-- <span class="p-float-label">
                                  <p-datepicker formControlName="fechabloqueoo" appendTo="body" [showIcon]="true"
                                      class="p-inputtext-sm" dateFormat="dd/mm/yy">
                                  </p-datepicker>
                                  <label for="float-label">Fecha Bloqueo</label>
                              </span> -->
                <p-floatlabel variant="on">
                  <p-datepicker formControlName="fechabloqueoo" appendTo="body" [showIcon]="true" class="p-inputtext-sm"
                    dateFormat="dd/mm/yy" styleClass="w-full md:w-full" inputStyleClass="w-full md:w-full">
                  </p-datepicker>
                  <label for="float-label">Fecha Bloqueo</label>
                </p-floatlabel>
              </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
              <div class="a-w1">
                <span style="font-size: 15px; display: flex;padding-top: 20px; padding-bottom: 15px;">Comentarios</span>
                <span class="p-float-label">
                  <textarea rows="5" cols="30" pInputTextarea formControlName="comentariobloqueo"
                    style="width: 100%;"></textarea>
                </span>
              </div>
            </div>
          </form>
        </p-accordionTab>
      </p-accordion>
    </p-tabPanel>
    <!-- <p-tabPanel header="Paquete Servicio" *ngIf="prueba">
      <form [formGroup]="groupPS" class="a-w1" style="margin: 0;">
        <div class="a-w1-row">
          <div class="a-w2">-->
    <!-- <span class="p-float-label">
                          <p-dropdown [options]="ListaTodosTipoDoc" placeholder="‎ " optionLabel="nombre"
                              formControlName="servicios" optionValue="codigo" appendTo="body" class="p-inputtext-sm"
                              (onChange)="verNumDoc($event)">
                          </p-dropdown>
                          <label for="float-label">Servicios</label>
                      </span> -->
    <!--  <p-floatlabel variant="in">
              <p-select [options]="ListaTodosTipoDoc" appendTo="body" formControlName="servicios"
                styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true" optionLabel="nombre" />
              <label for="anio">Servicios</label>
            </p-floatlabel>
          </div>
          <div class="a-w2" style="display: flex; flex-direction: column; gap: 20px;">

            <div class="a-w2">
              <div class="p-float-label flex align-items-center md:w-full">
                <p-checkbox formControlName="critico" [binary]="true" inputId="binary" class="mr-2"></p-checkbox>
                <label for="binary" class="text-sm">Crítico</label>
              </div>
            </div>
          </div>

          <div class="a-w2">
            <span class="p-float-label">
              <p-button icon="pi pi-plus" label="Agregar"></p-button>
            </span>
          </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
          <div class="a-w1-column">
            <app-datatable [metadataTable]="mdtS" [rowDelete]="true" [dataTable]="dtS">
            </app-datatable>
          </div>

        </div>
      </form>
    </p-tabPanel> -->
    <p-tabPanel header="Relacionados">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <form *ngIf="estadoEditar" [formGroup]="groupPoppupE" class="a-w1" style="margin: 0;">
        <div class="a-titulo">Datos del Cliente</div>
        <div class="a-example-full-width-alterno-content a-example-full-width-alterno-content-row">
          <div class="a-example-full-width-alterno-content-4">
            <p-floatlabel variant="in">
              <p-select [options]="ListaTodosTipoEntidad" placeholder="‎ " optionLabel="nombre"
                formControlName="tipoentidad" optionValue="codigo" appendTo="body" class="w-full md:w-full">
              </p-select>
              <label for="float-label">Tipo de Entidad</label>
            </p-floatlabel>
          </div>
          <div class="a-example-full-width-alterno-content-4">
            <p-floatlabel variant="in">
              <p-floatlabel variant="in">
                <input formControlName="numdocumento" type="text" pInputText />
                <label for="float-label">Número Documento</label>
              </p-floatlabel>
            </p-floatlabel>
          </div>
          <div class="a-example-full-width-alterno-content-4">
            <p-floatlabel variant="in">
              <p-floatlabel variant="in">
                <input formControlName="razonsocial" type="text" pInputText />
                <label for="float-label">Razón Social</label>
              </p-floatlabel>
            </p-floatlabel>
          </div>
        </div>
      </form>
      <div class="a-titulo" style="margin-top: 4px;">Datos del Relacionado</div>
      <app-datatable #dtEntidadRef [rowEdit]="true" [addRow]="true" [rowDelete]="true"
        [metadataTable]="metadataTableRelacionados" [dataTable]="dataTableRelacionados" [key]="'key'"
        [defaultRow]="defaultRowRelacionados" (onDpChangeEvento)="onEntidadChange($event)"
        [onDpValueChangeEvento]="onDpChangeTblRelacionados">
      </app-datatable>
    </p-tabPanel>
    <p-tabPanel header="Archivos">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <div>
        <p-fileUpload chooseLabel="Seleccionar Archivo" name="demo[]" [multiple]="true"
          url="https://www.primefaces.org/cdn/api/upload.php" [style]="{'width': '100%'}"
          accept="image/*,.xls,.xlsx,.pdf.docx,.txt,.doc" [maxFileSize]="1000000" (onSelect)="onUpload($event)"
          [auto]="true">
          <ng-template pTemplate="content" style="display: none;"></ng-template>
        </p-fileUpload>
        <!-- <p-button label="Guardar" icon="pi pi-save" (onClick)="onUpload($event)"></p-button> -->
        <div style="padding-top: 10px;">
          <p-table [value]="uploadedFiles" [tableStyle]="{'width': '100%','font-size': '13px', 'padding': '2px'}">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width:5%">Descargar</th>
                <th style="width:5%">Eliminar</th>
                <th style="width:17%">Tipo Doc.</th>
                <th style="width:18%">Usuario Crea</th>
                <th style="width:17%">Fecha Crea</th>
                <th style="width:36%">Nombre</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns">
              @if(row.tipotran != 'D'){
              <tr>
                <td><p-button class="btnsmall" icon="pi pi-download"
                    styleClass="p-button-rounded p-button-outlined p-button-sm"
                    (onClick)="downloadArchivo('',row)"></p-button></td>
                <td><p-button icon="pi pi-times"
                    styleClass="p-button-rounded p-button-danger p-button-outlined p-button-sm"
                    (onClick)="deleteArchivo(row)"></p-button></td>
                <td><img [src]="obtenerIconoTipoArchivo(row.nombre)"
                    style="width: 35px; height: 35px; margin-right: 10px;"></td>
                <td>{{row.usuario}}</td>
                <td>{{row.fecha}}</td>
                <td>{{row.nombre}}</td>
              </tr>
              }
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Auditoría">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <app-datatable [metadataTable]="metadataTableAuditoria" [dataTable]="dataTableAuditoria"
        [customButtons]="dataButtons">
      </app-datatable>
    </p-tabPanel>
  </p-tabView>
</p-dialog>